export default "__VITE_ASSET__CaDptOOT__"